/**
 * Dấu tích Xác minh danh tính (30/09/2026, docs/xac-minh-danh-tinh). Cùng nét vẽ
 * với app (HP-Media library/components/verified-tick). Hồng = tài khoản HP Media,
 * Xanh = đã xác minh danh tính. Tự vẽ, không dùng hình của TikTok.
 */
export type VerifiedBadge = 'PINK' | 'BLUE';

export const VERIFIED_BADGE_LABEL: Record<VerifiedBadge, string> = {
  PINK: 'Tích Hồng',
  BLUE: 'Tích Xanh',
};

export const VERIFIED_BADGE_MEANING: Record<VerifiedBadge, string> = {
  PINK: 'Tài khoản HP Media',
  BLUE: 'Tài khoản đã xác minh danh tính',
};

const FILL: Record<VerifiedBadge, string> = { PINK: '#C2337D', BLUE: '#20D5EC' };

/** Server mới trả verifiedBadge; server 29/09 chỉ có isPinkVerified. */
export function badgeOfUser(user: any): VerifiedBadge | null {
  const v = user?.verifiedBadge;
  if (v === 'PINK' || v === 'BLUE') return v;
  return user?.isPinkVerified ? 'PINK' : null;
}

export default function VerifiedTick({
  badge,
  size = 16,
}: {
  badge?: VerifiedBadge | null;
  size?: number;
}) {
  if (badge !== 'PINK' && badge !== 'BLUE') return null;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      role="img"
      aria-label={VERIFIED_BADGE_MEANING[badge]}
      style={{ flexShrink: 0, display: 'inline-block', verticalAlign: '-0.15em' }}
    >
      <title>{VERIFIED_BADGE_MEANING[badge]}</title>
      <circle cx="10" cy="10" r="9" fill={FILL[badge]} />
      <path
        d="m5.8 10.2 2.7 2.7 5.8-6"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
